package io.horion.cv.components


import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCalendar
import com.varabyte.kobweb.silk.components.icons.fa.FaClock
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.components.widgets.ColonneInfo
import io.horion.cv.models.Job
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun JobDetailsModal(
    isUser:Boolean,
    job: Job,
    onDismiss: () -> Unit,
    breakpoint: Breakpoint,
    onClick: () -> Unit,
    isDark :Boolean
) {
    val ctx = rememberPageContext()
    var isFavorite by remember { mutableStateOf(false) }
    val iconFilter = if (isDark) "invert(1)" else "none"

    // Overlay semi-transparent
    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(Colors.border)
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("z-index", "1000")
                property("background-color", "rgba(0, 0, 0, 0.5)")
            }
            .onClick { onDismiss() }
    ) {
        // Modal content
        Box(
            modifier = Modifier
                .styleModifier {
                    property("position", "fixed")
                    property("top", "50%")
                    property("left", "50%")
                    property("transform", "translate(-50%, -50%)")
                    property("max-height", "85vh")
                    property("overflow-y", "auto")
                    property("z-index", "1001")
                    property("animation", "popUp 0.28s cubic-bezier(0.34,1.56,0.64,1)")
                    property("box-shadow", "0 8px 28px rgba(0,0,0,0.5), 0 0 0 1px rgba(59,130,246,0.2)")
                }
                .backgroundColor(if (isDark) Colors.Primary else Colors.White)
                .border(1.px, LineStyle.Solid, Colors.border)
                .borderRadius(16.px)
                .fillMaxWidth(if (breakpoint<= Breakpoint.MD)90.percent else 60.percent)
                .margin(topBottom = 20.px)
                .onClick { it.stopPropagation() }
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(topBottom = 24.px, leftRight = 24.px),
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                // En-tête avec titre et bouton fermer
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                   Spacer()

                    // Bouton fermer
                    Box(
                        modifier = Modifier
                            .size(32.px)
                            .backgroundColor(Colors.LightGray)
                            .position(Position.Sticky)
                            .borderRadius(16.px)
                            .styleModifier {
                                property("cursor", "pointer")
                                property("display", "flex")
                                property("align-items", "center")
                                property("justify-content", "center")
                            }
                            .onClick { onDismiss() }
                    ) {
                        SpanText(
                            "✕",
                            modifier = Modifier
                                .fontSize(16.px)
                                .color(Colors.Black)
                        )
                    }
                }

                // Ligne séparatrice
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.px)
                        .backgroundColor(Colors.LightGray)
                )

                // Entreprise et titre et iccone favoris ou people


                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    SpanText(
                        text = job.enterprise,
                        modifier = Modifier
                            .fontSize(22.px)
                            .fontWeight(FontWeight.Bold)
                            .color(if (isDark) Colors.secondary else Colors.LighterBlue)
                    )

                    Image(
                        src = if (!isUser) "/evaluation.png" else if (isFavorite) "/favChecked.svg" else "/fav.svg",
                        description = "favori",
                        modifier = Modifier
                            .size(20.px)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                if (!isUser){
                                    ctx.router.navigateTo("/job/candidatures?id=${job.id}")
                                }else {
                                    isFavorite = !isFavorite
                                }
                            }
                            .styleModifier { property("filter", iconFilter) }

                    )
                }
                SpanText(
                    text = job.title,
                    modifier = Modifier
                        .fontSize(28.px)
                        .fontWeight(FontWeight.Bold)
                       // .color(Colors.Black)
                )

                // Localisation et type
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.spacedBy(12.px)
                ) {
                    Column(
                        modifier = Modifier.margin(top = 15.px)
                    ) {
                        ColonneInfo(//affiche la localisation, le type de job , l'experience et le status
                            job = job,
                            breakpoint = breakpoint,
                            vertical = true,
                            isDark = isDark
                        )
                    }

                    if (job.isRemote) {
                        DetailBadge(
                            icon = "/home-1.svg",
                            text = "Télétravail"
                        )
                    }
                }

                // Salaire
                DetailBadge(
                    icon = "/money-bag.svg",
                    text = "${job.salaryRange.min} - ${job.salaryRange.max} ${job.salaryRange.currency}",
                    modifier = Modifier.backgroundColor(Colors.secondary.copy(alpha = 1))
                )

                // Ligne séparatrice
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.px)
                        .backgroundColor(Colors.LightGray)
                )

                // Description
                SpanText(
                    text = "Description",
                    modifier = Modifier
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
                       // .color(Colors.Black)
                        .margin(bottom = 8.px)
                )
                SpanText(
                    text = job.description,
                    modifier = Modifier
                        .fontSize(18.px)
                        .color(if (isDark) Colors.White else Colors.Graytext)
                        .styleModifier { property("line-height", "1.6") }
                )

                // Prérequis
                SpanText(
                    text = "Prérequis",
                    modifier = Modifier
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
                      //  .color(Colors.Black)
                        .margin(top = 8.px, bottom = 8.px)
                )
                Column(verticalArrangement = Arrangement.spacedBy(8.px)) {
                    job.requirements.forEach { requirement ->
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            SpanText(
                                "• ",
                                modifier = Modifier
                                    .color(Colors.secondary)
                                    .fontSize(18.px)
                            )
                            SpanText(
                                requirement,
                                modifier = Modifier
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                                    .fontSize(18.px)
                                    .styleModifier { property("flex", "1") }
                            )
                        }
                    }
                }

                // Responsabilités
                SpanText(
                    text = "Responsabilités",
                    modifier = Modifier
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
                      //  .color(Colors.Black)
                        .margin(top = 8.px, bottom = 8.px)
                )
                Column(verticalArrangement = Arrangement.spacedBy(8.px)) {
                    job.responsibilities.forEach { responsibility ->
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            SpanText(
                                "• ",
                                modifier = Modifier
                                    .color(Colors.secondary)
                                    .fontSize(18.px)
                            )
                            SpanText(
                                responsibility,
                                modifier = Modifier
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                                    .fontSize(18.px)
                                    .styleModifier { property("flex", "1") }
                            )
                        }
                    }
                }

                // Tags
                if (job.tags.isNotEmpty()) {
                    SpanText(
                        text = "Compétences clés",
                        modifier = Modifier
                            .fontSize(22.px)
                            .fontWeight(FontWeight.Bold)
                           // .color(Colors.Black)
                            .margin(top = 8.px, bottom = 8.px)
                    )
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .flexWrap(FlexWrap.Wrap)
                            .gap(8.px)
                    ) {
                        job.tags.forEach { tag ->
                            Box(
                                modifier = Modifier
                                    .backgroundColor(Colors.secondary.copy(alpha = 1))
                                    .borderRadius(20.px)
                                    .padding(leftRight = 12.px, topBottom = 6.px)
                            ) {
                                SpanText(
                                    text = tag,
                                    modifier = Modifier
                                        .fontSize(18.px)
                                        .color(Colors.secondary)
                                )
                            }
                        }
                    }
                }

                // Informations supplémentaires
                SpanText(
                    text = "Informations supplémentaires",
                    modifier = Modifier
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
//                        .color(Colors.Black)
                        .margin(top = 8.px, bottom = 8.px)
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(24.px)
                ) {

                    // 📅 PUBLIÉ LE
                    Column {

                        Row(verticalAlignment = Alignment.CenterVertically) {
                            FaCalendar(
                                modifier = Modifier.margin(right = 8.px),
                                size = IconSize.SM
                            )

                            SpanText(
                                "Publié le",
                                modifier = Modifier
                                    .fontSize(18.px)
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                            )
                        }

                        SpanText(
                            job.publicateAt.split("T")[0],
                            modifier = Modifier
                                .fontSize(18.px)
                                .fontWeight(FontWeight.Medium)
                                .color(if (isDark) Colors.White else Colors.Black)
                                .margin(top = 4.px)
                        )
                    }

                    // ⏰ EXPIRATION
                    Column {

                        Row(verticalAlignment = Alignment.CenterVertically) {
                            FaClock(
                                modifier = Modifier.margin(right = 8.px),
                                size = IconSize.SM
                            )

                            SpanText(
                                "Expire le",
                                modifier = Modifier
                                    .fontSize(18.px)
                                    .color(if (isDark) Colors.White else Colors.Graytext)
                            )
                        }

                        SpanText(
                            job.expire.split("T")[0],
                            modifier = Modifier
                                .fontSize(18.px)
                                .fontWeight(FontWeight.Medium)
                                .color(if (isDark) Colors.White else Colors.Black)
                                .margin(top = 4.px)
                        )
                    }
                }

                Row(verticalAlignment = Alignment.CenterVertically){

                    FaEnvelope(
                        modifier = Modifier.margin(right = 8.px),
                        size = IconSize.SM
                    )
                    /* Image(
                        src = "envelope-mail.svg",
                        description = "icon",
                        modifier = Modifier.size(14.px)
                    )*/
                    SpanText(
                        text = " ${job.contactEmail}",
                        modifier = Modifier
                            .fontSize(18.px)
                            .color(Colors.secondary)
                    )
                }

                // Ligne séparatrice
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(1.px)
                        .backgroundColor(Colors.LightGray)
                        .margin(top = 8.px)
                )

                // Boutons d'action
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(top = 8.px),
                    horizontalArrangement = Arrangement.spacedBy(12.px, Alignment.CenterHorizontally)
                ) {
                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = {
                            if (!isUser){
                                ctx.router.navigateTo("/job/update?id=${job.id}")

                            }else {
                                //page pour postuler
                                onClick()
                            }
                        },
                        modifier = Modifier
                            .weight(1f)
                            .height(44.px)
                            .backgroundColor(Colors.secondary)
                            .borderRadius(8.px)
                            .styleModifier {
                                property("cursor", "pointer")
                                property("transition", "all 0.2s ease")
                            }
                    ) {
                        SpanText(
                            if (!isUser){
                                "Modifier"
                            }else {
                                "Postuler"
                            },
                            modifier = Modifier
                               // .color(Colors.White)
                                .fontWeight(FontWeight.Medium)
                        )
                    }

                    com.varabyte.kobweb.silk.components.forms.Button(
                        onClick = { onDismiss() },
                        modifier = Modifier
                            .weight(1f)
                            .height(44.px)
                            .backgroundColor(Colors.LightGray)
                            .borderRadius(8.px)
                            .styleModifier {
                                property("cursor", "pointer")
                                property("transition", "all 0.2s ease")
                            }
                    ) {
                        SpanText(if (!isUser){
                            "Supprimer"
                        }else {
                            "Fermer"
                        },
                            modifier = Modifier
                                .color(Colors.Black)
                                .fontWeight(FontWeight.Medium)
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun DetailBadge(
    icon: String,
    text: String,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier
            .backgroundColor(Colors.LightGray)
            .borderRadius(20.px)
            .padding(leftRight = 12.px, topBottom = 6.px),
        horizontalArrangement = Arrangement.spacedBy(6.px),
        verticalAlignment = Alignment.CenterVertically
    ) {

        Image(
            src = icon,
            description = "icon",
            modifier = Modifier.size(16.px)
        )
        SpanText(
            text,
            modifier = Modifier
                .fontSize(13.px)
                .color(Colors.Graytext)
        )
    }
}
